import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import { errorMsg } from '@/lib/recuentos';
import { ajustesAPI } from './ajustesApi';
import { NombreEditable } from './BodegasTab';

export const LocalesTab = () => {
  const [rows, setRows] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [cambio, setCambio] = useState(null);
  const [verInactivos, setVerInactivos] = useState(true);
  const load = () => Promise.all([ajustesAPI.locales(), ajustesAPI.bodegas()]).then(([l, b]) => { setRows(l.data); setBodegas(b.data); });
  useEffect(() => { load(); }, []);

  const update = async (l, data, okMsg) => {
    try { await ajustesAPI.updateLocal(l.id, data); toast.success(okMsg); load(); return true; }
    catch (e) { toast.error(errorMsg(e, 'Error al guardar')); return false; }
  };
  const confirmar = async () => {
    if (await update(cambio.local, { warehouse_id: cambio.nueva.id }, 'Bodega asignada')) setCambio(null);
  };
  const visibles = rows.filter((l) => verInactivos || l.is_active);

  return (
    <div className="space-y-4 mt-4">
      <label className="flex items-center gap-2 text-sm text-slate-600">
        <Switch checked={verInactivos} onCheckedChange={setVerInactivos} data-testid="locales-ver-inactivos" /> Mostrar inactivos
      </label>
      <p className="text-xs text-slate-500">Cambiar la bodega aplica a pedidos y despachos nuevos; los despachos anteriores conservan su bodega de origen. La bodega propia es la Bodega Principal del local: su stock se muestra como "Stock local" al iniciar un despacho. Los locales inactivos no aparecen en pedidos, despachos ni en Despachos Justo.</p>
      <div className="bg-white rounded-xl border overflow-x-auto">
        <table className="w-full text-sm" data-testid="locales-table">
          <thead className="bg-slate-50 text-slate-600"><tr>
            <th className="px-4 py-2 text-left">Nombre</th><th className="px-4 py-2 text-left">Bodega que lo abastece</th><th className="px-4 py-2 text-left">Bodega propia del local</th>
            <th className="px-4 py-2 text-left">Destino en Justo</th><th className="px-4 py-2 text-center">Activo</th>
          </tr></thead>
          <tbody>{visibles.map((l) => (
            <tr key={l.id} className={`border-t ${l.is_active ? '' : 'opacity-60'}`} data-testid={`local-row-${l.id}`}>
              <td className="px-4 py-2"><NombreEditable value={l.name} testId={`local-nombre-${l.id}`} onSave={(v) => update(l, { name: v }, 'Nombre actualizado')} /></td>
              <td className="px-4 py-2">
                <select value={l.warehouse_id || ''} className="h-9 rounded-md border px-2 text-sm" data-testid={`local-bodega-${l.id}`}
                  onChange={(e) => setCambio({ local: l, nueva: bodegas.find((b) => b.id === e.target.value) })}>
                  {!l.warehouse_id && <option value="">— Sin bodega —</option>}
                  {bodegas.filter((b) => b.is_active || b.id === l.warehouse_id).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                </select>
              </td>
              <td className="px-4 py-2">
                <select value={l.local_warehouse_id || ''} className="h-9 rounded-md border px-2 text-sm" data-testid={`local-bodega-propia-${l.id}`}
                  onChange={(e) => update(l, { local_warehouse_id: e.target.value }, 'Bodega propia actualizada')}>
                  <option value="">— Sin bodega propia —</option>
                  {bodegas.filter((b) => b.is_active || b.id === l.local_warehouse_id).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                </select>
              </td>
              <td className="px-4 py-2 text-xs">{l.destino_justo || <span className="text-slate-400">No se exporta</span>}</td>
              <td className="px-4 py-2 text-center"><Switch checked={l.is_active} onCheckedChange={(c) => update(l, { is_active: c }, c ? 'Local activado' : 'Local desactivado')} data-testid={`local-activo-${l.id}`} /></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <Dialog open={!!cambio} onOpenChange={(o) => !o && setCambio(null)}>
        <DialogContent className="max-w-md" data-testid="local-cambio-dialog">
          <DialogHeader><DialogTitle>Cambiar bodega</DialogTitle></DialogHeader>
          {cambio && (
            <p className="text-sm text-slate-700" data-testid="local-cambio-resumen">
              <b>{cambio.local.name}</b> pasará de <b>{cambio.local.warehouse_name || 'sin bodega'}</b> a <b>{cambio.nueva?.name}</b>. Los despachos anteriores no cambian.
            </p>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setCambio(null)}>Cancelar</Button>
            <Button onClick={confirmar} className="bg-orange-500 hover:bg-orange-600" data-testid="local-cambio-confirmar">Confirmar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
